package com.example.mystybag.common.model

data class MainUIState(
    val showInitialDataProgress     : Boolean = false,
    val showNotificationProgress    : Boolean = false,
    val showTaxesDialog             : Boolean = false
)